import { useSelector } from 'react-redux';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import Loader from './Ui/Loader';

const ProtectedRoute = ({ allowedRoles, requiredViewType }) => {
  const location = useLocation();
  const {
    viewType,
    loading,
    user: { role = [] } = {},
    isLoggedIn,
  } = useSelector((state) => state.userInfo);

  if (loading) {
    return <Loader />; // Or a spinner component
  }

  // If no user is logged in, redirect to login
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user's role is not allowed, redirect to unauthorized
  if (!allowedRoles.some((item) => role.includes(item))) {
    return <Navigate to="/unauthorized" replace />;
  }

  // If a requiredViewType is specified and it doesn't match the current viewType, redirect to unauthorized
  if (requiredViewType && viewType !== requiredViewType) {
    return <Navigate to="/unauthorized" replace />;
  }

  // Render child routes using Outlet
  return <Outlet />;
};

export default ProtectedRoute;
